export const UpsellPromoType = {
  AUTO_GRATUITY: 'AUTO_GRATUITY',
  CLOSE_OF_DAY: 'CLOSE_OF_DAY',
  COURSE_MANAGEMENT: 'COURSE_MANAGEMENT',
  INSTANT_PAYOUTS: 'INSTANT_PAYOUTS',
  INVENTORY: 'INVENTORY',
  ORDER_GUIDE: 'ORDER_GUIDE',
  MENU_REPORTS: 'MENU_REPORTS',
  NOTIFY_WHEN_READY: 'NOTIFY_WHEN_READY',
  REOPEN_CLOSED_CHECKS: 'REOPEN_CLOSED_CHECKS',
  SEAT_MANAGEMENT: 'SEAT_MANAGEMENT',
  SECTION_SALES: 'SECTION_SALES',
  SHARED_SETTINGS: 'SHARED_SETTINGS',
  TABLE_TIMERS: 'TABLE_TIMERS',
  KITCHEN_DISPLAY_SYSTEM: 'KITCHEN_DISPLAY_SYSTEM',
  SCAN_TO_PAY: 'SCAN_TO_PAY',
  ADDITIONAL_COUNTERTOP_POS: 'ADDITIONAL_COUNTERTOP_POS',
  COMBOS: 'COMBOS',
  MOBILE: 'MOBILE',
  KIOSK: 'KIOSK'
};